import { render, staticRenderFns } from "./order-create-form.vue?vue&type=template&id=1c479230&"
import script from "./order-create-form.ts?vue&type=script&lang=ts&"
export * from "./order-create-form.ts?vue&type=script&lang=ts&"
import style0 from "./order-create-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports